export interface CommercialHub {
  id: string;
  name: string;
  country: string;
  city: string;
  flag: string;
  merchantsCount: string;
  corridor: string;
  address: string;
  lat: number;
  lng: number;
  heading: number;
  pitch: number;
  dispatchTime: string;
  specialty: string;
  established: string;
}

export const COMMERCIAL_HUBS: CommercialHub[] = [
  // --- NIGERIA ---
  {
    id: 'ladipo',
    name: 'Ladipo International Market',
    country: 'Nigeria',
    city: 'Lagos, Nigeria',
    flag: '🇳🇬',
    merchantsCount: '5,500+ Merchants',
    corridor: 'Mushin / Oshodi-Isolo Commercial Belt',
    address: 'Ladipo International Market, Mushin, Lagos 100253, Nigeria',
    lat: 6.5355,
    lng: 3.3482,
    heading: 120,
    pitch: 5,
    dispatchTime: 'Under 30 mins',
    specialty: 'Japanese & German OEM, Complete Half-Cuts, Transmissions, Engines',
    established: '1978'
  },
  {
    id: 'aspamda',
    name: 'ASPAMDA Trade Fair Complex',
    country: 'Nigeria',
    city: 'Lagos, Nigeria',
    flag: '🇳🇬',
    merchantsCount: '4,800+ Direct Importers',
    corridor: 'Badagry Expressway International Trade Corridor',
    address: 'Auto Spare Parts and Machinery Dealers Association, Trade Fair, Lagos, Nigeria',
    lat: 6.4674,
    lng: 3.2415,
    heading: 90,
    pitch: 0,
    dispatchTime: 'Under 45 mins',
    specialty: 'Containerized Bulk Wholesale, Brand New OEM & Tier-1 Global Imports',
    established: '1995'
  },
  {
    id: 'nnewi',
    name: 'Nkwo Nnewi Auto Spares Triangle',
    country: 'Nigeria',
    city: 'Nnewi, Anambra',
    flag: '🇳🇬',
    merchantsCount: '3,800+ Factories & Wholesalers',
    corridor: 'Nkwo Nnewi Industrial Triangle',
    address: 'Nkwo Nnewi Central Auto Parts Market, Nnewi, Anambra State, Nigeria',
    lat: 6.0198,
    lng: 6.9149,
    heading: 45,
    pitch: 0,
    dispatchTime: 'Under 45 mins',
    specialty: 'Manufacturing, Motor & Heavy Truck Spares, Innoson Direct Supply',
    established: '1970'
  },
  {
    id: 'apo_mechanic',
    name: 'Apo Mechanic Village',
    country: 'Nigeria',
    city: 'Abuja (FCT), Nigeria',
    flag: '🇳🇬',
    merchantsCount: '2,600+ Workshops & Stores',
    corridor: 'Apo Resettlement & Expressway Hub',
    address: 'Apo Mechanic Village, Gudu District, Abuja, Nigeria',
    lat: 8.9950,
    lng: 7.4920,
    heading: 0,
    pitch: 5,
    dispatchTime: 'Under 30 mins',
    specialty: 'Federal Capital Fleet Diagnostics, Mercedes, Lexus & Toyota Genuine OEM',
    established: '1990'
  },
  {
    id: 'kano_kofar',
    name: 'Kofar Ruwa Auto Market',
    country: 'Nigeria',
    city: 'Kano, Nigeria',
    flag: '🇳🇬',
    merchantsCount: '3,200+ Merchants',
    corridor: 'Dala / Kofar Ruwa Northern Transit Corridor',
    address: 'Kofar Ruwa Spare Parts Market, Dala, Kano State, Nigeria',
    lat: 12.0125,
    lng: 8.5122,
    heading: 180,
    pitch: 0,
    dispatchTime: 'Under 60 mins',
    specialty: 'Trans-Saharan Logistics Trucks, Commercial Pickups & Agricultural Diesel',
    established: '1981'
  },

  // --- GHANA ---
  {
    id: 'abossey_okai',
    name: 'Abossey Okai Spare Parts Hub',
    country: 'Ghana',
    city: 'Accra, Ghana',
    flag: '🇬🇭',
    merchantsCount: '2,400+ Merchants',
    corridor: 'Kaneshie - Abossey Okai Auto Commercial Belt',
    address: 'Abossey Okai Spare Parts Hub, Accra, Ghana',
    lat: 5.5562,
    lng: -0.2312,
    heading: 90,
    pitch: 0,
    dispatchTime: 'Under 45 mins',
    specialty: 'Toyota, Hyundai, Kia Genuine & Tier-1 Filtration & Suspension',
    established: '1982'
  },
  {
    id: 'suame_magazine',
    name: 'Suame Magazine Industrial Belt',
    country: 'Ghana',
    city: 'Kumasi, Ghana',
    flag: '🇬🇭',
    merchantsCount: '4,000+ Artisans & Shops',
    corridor: 'Kumasi Northern Industrial Belt',
    address: 'Suame Magazine Industrial Area, Kumasi, Ashanti Region, Ghana',
    lat: 6.7214,
    lng: -1.6318,
    heading: 270,
    pitch: 0,
    dispatchTime: 'Under 45 mins',
    specialty: 'Engine Rebuilding, Heavy Machinery, Metal Casting, Gearboxes',
    established: '1935'
  },

  // --- KENYA ---
  {
    id: 'kirinyaga',
    name: 'Kirinyaga Road Commercial Belt',
    country: 'Kenya',
    city: 'Nairobi, Kenya',
    flag: '🇰🇪',
    merchantsCount: '1,900+ Specialists',
    corridor: 'Downtown Nairobi Auto Spares District',
    address: 'Kirinyaga Road, Central Business District, Nairobi, Kenya',
    lat: -1.2825,
    lng: 36.8280,
    heading: 60,
    pitch: 0,
    dispatchTime: 'Under 40 mins',
    specialty: 'Japanese Saloon & SUV Spares (Subaru, Toyota, Isuzu, Nissan)',
    established: '1972'
  },
  {
    id: 'industrial_area',
    name: 'Nairobi Industrial Area Hub',
    country: 'Kenya',
    city: 'Nairobi, Kenya',
    flag: '🇰🇪',
    merchantsCount: '1,500+ Importers',
    corridor: 'Enterprise Road Logistics Corridor',
    address: 'Enterprise Rd, Industrial Area, Nairobi, Kenya',
    lat: -1.3060,
    lng: 36.8520,
    heading: 180,
    pitch: 0,
    dispatchTime: 'Under 50 mins',
    specialty: 'Heavy Commercial Fleets, Scania, Mercedes Actros, Safari 4WD Suspensions',
    established: '1974'
  },

  // --- TANZANIA ---
  {
    id: 'kariakoo',
    name: 'Kariakoo & Gerezani Auto District',
    country: 'Tanzania',
    city: 'Dar es Salaam, Tanzania',
    flag: '🇹🇿',
    merchantsCount: '1,400+ Merchants',
    corridor: 'Swahili & Msimbazi Commercial Corridor',
    address: 'Kariakoo Spare Parts District, Ilala, Dar es Salaam, Tanzania',
    lat: -6.8208,
    lng: 39.2783,
    heading: 45,
    pitch: 5,
    dispatchTime: 'Under 60 mins',
    specialty: 'East African 4WD Land Cruiser, Safari Suspensions & Cross-Border Logistics',
    established: '1991'
  },

  // --- SOUTH AFRICA ---
  {
    id: 'selby_jhb',
    name: 'Selby & Booysens Industrial Hub',
    country: 'South Africa',
    city: 'Johannesburg, South Africa',
    flag: '🇿🇦',
    merchantsCount: '2,800+ Warehouses & Scrapyards',
    corridor: 'M2 Highway / Booysens Road Industrial Corridor',
    address: 'Selby Industrial Area, Johannesburg 2001, Gauteng, South Africa',
    lat: -26.2167,
    lng: 28.0333,
    heading: 135,
    pitch: 0,
    dispatchTime: 'Under 40 mins',
    specialty: 'High-Performance European OE, Precision Scrap Salvage & Mining Fleets',
    established: '1965'
  },

  // --- EGYPT ---
  {
    id: 'tewfikia',
    name: 'Tewfikia & El-Dars Auto Spare Parts',
    country: 'Egypt',
    city: 'Cairo, Egypt',
    flag: '🇪🇬',
    merchantsCount: '3,500+ Traders & Fabricators',
    corridor: 'Downtown Cairo / Ramses Commercial Corridor',
    address: 'Souq El Tewfikia, Azbakeya, Cairo Governorate, Egypt',
    lat: 30.0520,
    lng: 31.2410,
    heading: 200,
    pitch: 0,
    dispatchTime: 'Under 45 mins',
    specialty: 'North African Tier-1 Manufacturing, European & Korean Passenger Components',
    established: '1952'
  },

  // --- MOROCCO ---
  {
    id: 'derb_omar',
    name: 'Derb Omar & Lalla Yacout Corridor',
    country: 'Morocco',
    city: 'Casablanca, Morocco',
    flag: '🇲🇦',
    merchantsCount: '2,900+ Distributors',
    corridor: 'Boulevard Mohammed V Commercial Axis',
    address: 'Derb Omar, Casablanca 20250, Morocco',
    lat: 33.5900,
    lng: -7.6167,
    heading: 110,
    pitch: 0,
    dispatchTime: 'Under 50 mins',
    specialty: 'Renault, Dacia, Peugeot & Stellantis OEM Integrated Supply Chain',
    established: '1960'
  },

  // --- ALGERIA ---
  {
    id: 'oued_smar',
    name: 'Oued Smar & El Harrach Auto Zone',
    country: 'Algeria',
    city: 'Algiers, Algeria',
    flag: '🇩🇿',
    merchantsCount: '2,100+ Authorized Stockists',
    corridor: 'Zone Industrielle Oued Smar, Algiers',
    address: 'Zone Industrielle Oued Smar, Algiers 16200, Algeria',
    lat: 36.7028,
    lng: 3.1611,
    heading: 90,
    pitch: 0,
    dispatchTime: 'Under 60 mins',
    specialty: 'Brand-New European Aftermarket (Renault, Peugeot, Volkswagen, Bosch)',
    established: '1984'
  },

  // --- CÔTE D'IVOIRE ---
  {
    id: 'adjame',
    name: 'Marché Adjamé & Marcory Hub',
    country: "Côte d'Ivoire",
    city: "Abidjan, Côte d'Ivoire",
    flag: '🇨🇮',
    merchantsCount: '2,300+ Merchants',
    corridor: 'Boulevard Nangui Abrogoua / Adjamé Belt',
    address: "Marché Adjamé, Abidjan, Côte d'Ivoire",
    lat: 5.3600,
    lng: -4.0267,
    heading: 150,
    pitch: 0,
    dispatchTime: 'Under 45 mins',
    specialty: 'Francophone West Africa Apex Hub: French & Japanese Vehicle Components',
    established: '1979'
  },

  // --- SENEGAL ---
  {
    id: 'medina_dakar',
    name: 'Médina & Marché Castors Corridor',
    country: 'Senegal',
    city: 'Dakar, Senegal',
    flag: '🇸🇳',
    merchantsCount: '1,700+ Merchants',
    corridor: 'Avenue Blaise Diagne / Médina Commercial District',
    address: 'Médina, Dakar, Senegal',
    lat: 14.6928,
    lng: -17.4467,
    heading: 75,
    pitch: 0,
    dispatchTime: 'Under 50 mins',
    specialty: 'Coastal Transit & Redistribution, Peugeot, Toyota, Mercedes Commercial Vans',
    established: '1980'
  },

  // --- CAMEROON ---
  {
    id: 'ndogbong',
    name: 'Ndogbong & Akwa Auto Zones',
    country: 'Cameroon',
    city: 'Douala, Cameroon',
    flag: '🇨🇲',
    merchantsCount: '1,850+ Merchants',
    corridor: 'Zone Industrielle Ndogbong / Boulevard de la Liberté',
    address: 'Ndogbong, Douala, Cameroon',
    lat: 4.0511,
    lng: 9.7679,
    heading: 210,
    pitch: 0,
    dispatchTime: 'Under 50 mins',
    specialty: 'Central African Sub-Regional Gateway, Heavy Loggers & Consumer 4x4 Spares',
    established: '1983'
  },

  // --- BENIN ---
  {
    id: 'dantokpa',
    name: 'Marché Dantokpa & Akpakpa Zone',
    country: 'Benin',
    city: 'Cotonou, Benin',
    flag: '🇧🇯',
    merchantsCount: '1,600+ Traders',
    corridor: 'Boulevard Saint-Michel & Akpakpa Maritime Corridor',
    address: 'Marché Dantokpa, Cotonou, Benin',
    lat: 6.3719,
    lng: 2.4347,
    heading: 90,
    pitch: 0,
    dispatchTime: 'Under 40 mins',
    specialty: 'Re-Export Corridor supplying Niger, Burkina Faso, and cross-border Nigeria',
    established: '1976'
  },

  // --- ETHIOPIA ---
  {
    id: 'somale_tera',
    name: 'Somale Tera (Merkato Auto Hub)',
    country: 'Ethiopia',
    city: 'Addis Ababa, Ethiopia',
    flag: '🇪🇹',
    merchantsCount: '3,100+ Commercial Outlets',
    corridor: 'Addis Ketema / Merkato Commercial Zone',
    address: 'Somale Tera, Merkato, Addis Ababa, Ethiopia',
    lat: 9.0300,
    lng: 38.7400,
    heading: 300,
    pitch: 0,
    dispatchTime: 'Under 60 mins',
    specialty: 'Heavy Truck Transit Spares, Toyota OEM, High-Altitude Retrofitting',
    established: '1968'
  },

  // --- UGANDA ---
  {
    id: 'katwe',
    name: 'Katwe & Kisenyi Engineering Hub',
    country: 'Uganda',
    city: 'Kampala, Uganda',
    flag: '🇺🇬',
    merchantsCount: '2,200+ Workshops & Parts Stores',
    corridor: "Katwe Road / Queen's Way Engineering District",
    address: 'Katwe Auto Commercial Corridor, Kampala, Uganda',
    lat: 0.3033,
    lng: 32.5731,
    heading: 140,
    pitch: 0,
    dispatchTime: 'Under 45 mins',
    specialty: 'Localized Engineering Adaptation, Gearbox Rebuilding, Matatu Van Fleet Spares',
    established: '1975'
  },

  // --- ANGOLA ---
  {
    id: 'mercado_correios',
    name: 'Mercado dos Correios & Palanca',
    country: 'Angola',
    city: 'Luanda, Angola',
    flag: '🇦🇴',
    merchantsCount: '1,750+ Traders',
    corridor: 'Avenida Deolinda Rodrigues Corridor',
    address: 'Mercado dos Correios, Rangel, Luanda, Angola',
    lat: -8.8383,
    lng: 13.2344,
    heading: 100,
    pitch: 0,
    dispatchTime: 'Under 60 mins',
    specialty: 'Imported Japanese Peças Usadas, Toyota Hilux & HiAce Assemblies',
    established: '1988'
  },

  // --- DEMOCRATIC REPUBLIC OF CONGO ---
  {
    id: 'barumbu',
    name: 'Barumbu & Avenue du Commerce',
    country: 'DR Congo',
    city: 'Kinshasa, DR Congo',
    flag: '🇨🇩',
    merchantsCount: '2,500+ Traders',
    corridor: 'Boulevard du 30 Juin / Barumbu Industrial Zone',
    address: 'Barumbu, Kinshasa, Democratic Republic of the Congo',
    lat: -4.3167,
    lng: 15.3167,
    heading: 180,
    pitch: 0,
    dispatchTime: 'Under 60 mins',
    specialty: 'River Port Transit, Heavy Mining Vehicle Spares & Consumer 4WD Assemblies',
    established: '1980'
  },

  // --- ZAMBIA ---
  {
    id: 'kamwala',
    name: 'Kamwala & Lumumba Road Corridor',
    country: 'Zambia',
    city: 'Lusaka, Zambia',
    flag: '🇿🇲',
    merchantsCount: '1,300+ Merchants',
    corridor: 'Lumumba Road Commercial & Mining Fleet Belt',
    address: 'Lumumba Road, Lusaka, Zambia',
    lat: -15.4267,
    lng: 28.2833,
    heading: 120,
    pitch: 0,
    dispatchTime: 'Under 45 mins',
    specialty: 'Copperbelt Transit Trucks, Asian Right-Hand-Drive Passenger Spares',
    established: '1985'
  },

  // --- ZIMBABWE ---
  {
    id: 'graniteside',
    name: 'Graniteside & Kaguvi Street',
    country: 'Zimbabwe',
    city: 'Harare, Zimbabwe',
    flag: '🇿🇼',
    merchantsCount: '1,650+ Stockists',
    corridor: 'Kaguvi Street Downtown / Graniteside Industrial',
    address: 'Kaguvi Street, Harare, Zimbabwe',
    lat: -17.8489,
    lng: 31.0531,
    heading: 90,
    pitch: 0,
    dispatchTime: 'Under 45 mins',
    specialty: 'South African & Asian OEM Imports, Agricultural & Consumer Vehicle Spares',
    established: '1980'
  },

  // --- RWANDA ---
  {
    id: 'gakinjiro',
    name: 'Gakinjiro & Muhima Auto Zone',
    country: 'Rwanda',
    city: 'Kigali, Rwanda',
    flag: '🇷🇼',
    merchantsCount: '1,100+ Merchants',
    corridor: 'Nyarugenge / Muhima Commercial Corridor',
    address: 'Gakinjiro, Nyarugenge, Kigali, Rwanda',
    lat: -1.9441,
    lng: 30.0588,
    heading: 45,
    pitch: 0,
    dispatchTime: 'Under 35 mins',
    specialty: 'High-Quality Certified European & Japanese Maintenance Consumables',
    established: '1998'
  }
];

export function getHubById(id?: string): CommercialHub {
  if (!id) return COMMERCIAL_HUBS[0];
  const cleanId = id.toLowerCase().trim();
  return COMMERCIAL_HUBS.find((h) => h.id === cleanId || h.name.toLowerCase().includes(cleanId)) || COMMERCIAL_HUBS[0];
}
